module.exports = __webpack_public_path__ + "static/type-color-panels-3eb84dc6c79fc213e4c42da2b42c65d5.svg";